<template>
  <div class="martrialStyle">
    <span class="title">办事材料</span>
    <span style="color: #1677FF;margin-left:22px;cursor: pointer;" @click="isShowSitution(true)" v-if="situation !== 'off' && !showSitution && situationDataBeanList && situationDataBeanList.length >0">
      <a-icon :component="Edit"></a-icon>修改情形
    </span>
    <PreviewSitution
      v-if="situation !== 'off' && showSitution && situationDataBeanList && situationDataBeanList.length >0"
      :itemType="itemType"
      :situationDataBeanList="situationDataBeanList"
      @isShowSitution="isShowSitution"
      @situionIds="getMatrial"/>
    <div style="position:relative" v-if="situation === 'off' || !showSitution || !(situationDataBeanList && situationDataBeanList.length >0)">
      <a-table
        style="margin-top:20px"
        :columns="columns"
        :dataSource="showTableData"
        :pagination="false"
        :rowKey="(record) => record.key || record.iid">
        <template slot="index" slot-scope="text,record,index">
          {{ index+1 }}
        </template>
        <template slot="materialName" slot-scope="text,record">
          <!-- <a v-if="record.annexExampleUrl" @click="showExample()" style="width:180px; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" :title="record.materialName">{{ record.materialName }}<a-icon type="eye" /></a> -->
          <div style="display: flex;align-items: center;">
            <div style="maxWidth:144px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;" :title="record.materialName">{{ record.materialName }}</div>
            <a target="_blank" :href="record.annexExampleUrl" v-if="record.annexExampleUrl" style="margin-left: 10px"><a-icon type="eye" /></a>
          </div>
          <a-tag v-if="record.ifSubmit && record.ifSubmit === '01' " color="orange">免提交</a-tag>
        </template>
        <template slot="materialNecessity" slot-scope="text,record">
          <a-tag :color="text | statusTypeFilter"> {{ transform('materialNecessity',record.materialNecessity) }}</a-tag>
        </template>
        <template slot="materialType" slot-scope="text,record">
          {{ transform('materialType',record.materialType, record) }}
        </template>
        <template slot="materialFrom" slot-scope="text,record">
          {{ transform('materialFrom',record.materialFrom) }}
        </template>
        <template slot="sourceChannels" slot-scope="text,record">
          {{ transform('sourceChannels',record.sourceChannels) }}
        </template>
        <template slot="annexBlankUrl" slot-scope="text,record">
          <span @click="downMaterial(record.annexBlankUrl, record.annexBlankName)" v-if="record.annexBlankUrl!==null&&record.annexBlankUrl!==''" style="color:#1777ff;cursor: pointer;">
            <a-icon :component="IconDownload" style="vertical-align:middle"></a-icon><span style="margin-left:3px">空表下载</span>
          </span>
          <span v-else>--</span>
        </template>
      </a-table>
      <div
        v-if="showMoreTable"
        style="position:absolute;bottom:0;
      text-align:center;background:rgba(230, 247, 255,0.5);
      width:100%;height:20px;line-height:20px"
        @click="getMoreData">
        <a-icon :component="DownMore"></a-icon>
      </div>
      <div
        v-if="hideMoreTable"
        style="position:absolute;bottom:0;
      text-align:center;background:rgba(230, 247, 255,0.5);
      width:100%;height:20px;line-height:20px"
        @click="hideMoreData">
        <a-icon :component="DownMore" style="transform: rotate(180deg);"></a-icon>
      </div>
    </div>
    <h-download ref="hDownload" :hrefUrl="hrefUrl" :fileName="fileName"></h-download>
  </div>
</template>

<script>
import Edit from '@ant-design/icons/svg/outline/edit.svg?inline'
import IconDownload from '@ant-design/icons/svg/outline/download.svg?inline'
import DownMore from './../../../../assets/jiopweb3.0.0/downMore.svg?inline'
import { HDownload } from 'jpaas-component'
import PreviewSitution from './previewSitution.vue'
import { jiopAPI } from '@/api/jiopweb/jiop'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb-x'
export default {
  components: {
    HDownload,
    PreviewSitution
  },
  props: {
    itemId: {
      type: String,
      default: ''
    },
    itemType: {
      type: String,
      default: ''
    },
    situationDataBeanList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    },
    situation: {
      type: String,
      default: 'off'
    }
  },
  filters: {
    statusTypeFilter (status) {
      const statusMap = {
        '01': 'red',
        '02': 'orange',
        '03': 'green',
        '04': 'blue'
      }
      // 当有新的类型的时候，颜色默认用蓝色
      if (!statusMap[status]) {
        return 'blue'
      }
      return statusMap[status]
    }
  },
  data () {
    return {
      Edit,
      hrefUrl: '',
      IconDownload,
      showTableData: [],
      middleData: [],
      count: 0,
      DownMore,
      showSitution: true,
      showMoreTable: false,
      hideMoreTable: false,
      materialTypeMeta: [],
      materialFromMeta: [],
      sourceChannelsMeta: [],
      materialNecessityMeta: [],
      fileName: '',
      columns: [
        {
          title: '必要性',
          dataIndex: 'materialNecessity',
          scopedSlots: { customRender: 'materialNecessity' },
          width: 80
        },
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' },
          width: 60
        },
        {
          title: '材料名称及示例样本',
          dataIndex: 'materialName',
          width: 200,
          scopedSlots: { customRender: 'materialName' }
        },
        {
          title: '类型及份数',
          dataIndex: 'materialType',
          width: 120,
          scopedSlots: { customRender: 'materialType' }
        },
        {
          title: '形式',
          dataIndex: 'materialFrom',
          width: 80,
          scopedSlots: { customRender: 'materialFrom' }
        },
        {
          title: '来源',
          dataIndex: 'sourceChannels',
          scopedSlots: { customRender: 'sourceChannels' }
        },
        {
          title: '材料下载',
          dataIndex: 'annexBlankUrl',
          align: 'center',
          scopedSlots: { customRender: 'annexBlankUrl' }
        }

      ],
      mockData: []
    }
  },
  destroyed () {
    this.count = 0
  },
  created () {
    this.count = 0
    this.$forceUpdate()
  },
  methods: {
    getStartData (data) {
      this.mockData = data
      if (this.mockData.length > 6) {
        this.showMoreTable = true
        for (let i = 0; i < this.mockData.length; i += 6) {
          this.middleData.push(this.mockData.slice(i, i + 6))
        }
        this.showTableData = this.middleData[0]
      } else {
        this.showTableData = this.mockData
        this.showMoreTable = false
      }
    },
    // 获取更多数据
    getMoreData () {
      this.count = this.count + 1
      if (this.count < this.middleData.length - 1) {
        this.showMoreTable = true
        let array = []
        for (let i = 0; i <= this.count;) {
          array = array.concat(this.middleData[i])
          i++
        }
        this.showTableData = array
      } else {
        this.showMoreTable = false
        this.hideMoreTable = true
        let array = []
        for (let i = 0; i <= this.count;) {
          array = array.concat(this.middleData[i])
          i++
        }
        this.showTableData = array
      }
    },
    // 收起数据
    hideMoreData () {
      this.showMoreTable = true
      this.hideMoreTable = false
      this.count = 0
      this.middleData = []
      for (let i = 0; i < this.mockData.length; i += 6) {
        this.middleData.push(this.mockData.slice(i, i + 6))
      }
      this.showTableData = this.middleData[0]
    },
    // 转换维度数据
    transform (type, value, record) {
      if (this.checkOutMetaList()) {
        if (type === 'materialNecessity') {
          const index = parseInt(value) - 1
          return this.materialNecessityMeta[index].name
        } else if (type === 'materialType') {
          const index = parseInt(value) - 1
          return this.materialTypeMeta[index].name + (record.matterPageNum ? record.matterPageNum + '份' : '')
        } else if (type === 'materialFrom') {
          const index = parseInt(value) - 1
          return this.materialFromMeta[index].name
        } else if (type === 'sourceChannels') {
          let str = '暂无'
          this.sourceChannelsMeta.forEach(item => {
            if (value === item.dictionaryCode) {
              str = item.name
            }
          })
          return str
        } else {
          return '暂无'
        }
      }
    },
    checkOutMetaList () {
      const flag = true
      if (this.materialTypeMeta === undefined || this.materialTypeMeta.length === 0) {
        return false
      }
      if (this.materialFromMeta === undefined || this.materialFromMeta.length === 0) {
        return false
      }
      if (this.sourceChannelsMeta === undefined || this.sourceChannelsMeta.length === 0) {
        return false
      }
      if (this.materialNecessityMeta === undefined || this.materialNecessityMeta.length === 0) {
        return false
      }
      return flag
    },
    getMatrial (value) {
      if (value.length > 0) {
        const that = this
        jiopWebAPI.findoptionvalfileidByIid({ iids: value }).then(res => {
          if (res.success) {
            that.findMaterial(res.data.optionvalfileids || ',')
          }
        })
      } else {
        this.$message.warning('请先做情形题！')
      }
    },
    isShowSitution (value, flag) {
      this.showSitution = value
      if (value === false) {
        this.findMaterial(flag)
      }
    },
    findMaterial (str) {
      jiopAPI.findMaterialByIids({ iids: str, itemId: this.itemId }).then(res => {
        if (res.success) {
          this.mockData = res.data.data
          if (this.mockData.length > 6) {
            this.showMoreTable = true
            for (let i = 0; i < this.mockData.length; i += 6) {
              this.middleData.push(this.mockData.slice(i, i + 6))
            }
            this.showTableData = this.middleData[0]
          } else {
            this.showTableData = this.mockData
            this.showMoreTable = false
          }
          this.showSitution = false
        }
      })
    },
    downMaterial (value, name) {
      this.hrefUrl = '/api-gateway/jpaas-jiop-web-server/front/file/download?filePath=' + value + '&fileName=' + name
      this.fileName = name
      this.$refs.hDownload.download()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-table-body::-webkit-scrollbar {
  width: 10px;
}
::v-deep .ant-table-body {
  overscroll-behavior: contain;
}
.martrialStyle {
  .title {
    font-size: 22px;
    color: #333333;
    font-weight: 500;
  }
}
</style>
